import {
  estimateurBudgetDetailPrixMock,
  estimateurBudgetSelectionMock,
  madeInFranceMock,
} from '@mock/schema/components';
import { mentionsBudgetDynamiquesMock } from '@mock/schema/components/mentions-budget-dynamiques.mock';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  estimateurBudgetDetailPrixMock,
  estimateurBudgetSelectionMock,
  madeInFranceMock,
  mentionsBudgetDynamiquesMock,
];

export const estimateurBudgetRecapMock: SlugPage = {
  ...pageBase({
    title: 'Estimateur de bugdet - Recap',
    type: 'estimateur-budget',
    language: 'fr-FR',
    headerId: 'tunnel-estimateur-fr',
    footerId: '',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
